const dateToLocale = (date: string, showTime: boolean = true) => {
    return new Date(date).toLocaleString([], { year: 'numeric', month: '2-digit', day: '2-digit', ...(showTime && {hour: '2-digit', minute:'2-digit'}) });
};

export { dateToLocale };
